import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  makeStyles,
  withStyles,
  Typography,
  IconButton,
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';



const dialogTitleStyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(dialogTitleStyles)((props) => {
  const { children, classes, onClose, ...other } = props;
  const { t } = useTranslation();

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label={t('common:close')} title={t('common:close')} className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles((theme) => ({
  dialog: {
    height: 'auto',
    width: 'auto',
    minWidth: '250px', //title + close icon
    maxWidth: '90%',
    maxHeight: '90%',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '100%',
      maxWidth: 'none',
      maxHeight: 'none',
      margin: 0
    },
  },
  dialogImage: {
    maxWidth: '100%'
  },
  dialogVideo: {
    maxWidth: '100%',
    height: 'auto'
  }
}));

const FileViewerDialog = (props) => {
  const classes = useStyles();
  const {
    open,
    title,
    file,
    handleClose
  } = props;

  return (
    <Dialog onClose={handleClose} aria-labelledby="dialog-title" open={open} classes={{ paper: classes.dialog}}>
      <DialogTitle id="dialog-title" onClose={handleClose}>{title}</DialogTitle>
      <DialogContent dividers>
        {file?.type === 'image' ? <img src={file.medium} alt="" className={classes.dialogImage} /> : null}
        {file?.type === 'video' ? <video controls autoPlay width="640" height="360" className={classes.dialogVideo}><source src={file.video} /></video> : null}
      </DialogContent>
    </Dialog>
  );
};

FileViewerDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  file: PropTypes.object,
  type: PropTypes.string,
  handleClose: PropTypes.func,
};

export default FileViewerDialog;
